<div dir="ltr">
  <div class="m-2 d-inline-block ppp-input-number">
    <p-inputNumber
      [(ngModel)]="limit"
      [min]="5"
      (ngModelChange)="onLimitChange()"
      [inputStyle]="{ 'text-align': 'right' }"
      [step]="10"
      [showButtons]="true"
      buttonLayout="horizontal"
      incrementButtonIcon="pi pi-plus"
      decrementButtonIcon="pi pi-minus"
    ></p-inputNumber>
    <label class="m-2 ms-label-view">{{ "Data Limit" | translator }}</label>
  </div>

  <div class="m-2 d-inline-block ppp-calander">
    <p-calendar
      class="ppp-calander"
      [(ngModel)]="endDate"
      [dateFormat]="'dd MM yy'"
      [minDate]="startDate"
      [maxDate]="today"
      (ngModelChange)="onDateChange()"
      [showIcon]="true"
      [showButtonBar]="true"
      [inputStyle]="{ 'text-align': 'right' }"
    >
    </p-calendar>
    <label class="m-2 ms-label-view">{{ "End Date" | translator }}</label>
  </div>

  <div class="m-2 d-inline-block ppp-calander">
    <p-calendar
      [(ngModel)]="startDate"
      [dateFormat]="'dd MM yy'"
      [maxDate]="endDate"
      (ngModelChange)="onDateChange()"
      [showIcon]="true"
      [showButtonBar]="true"
      [inputStyle]="{ 'text-align': 'right' }"
    >
    </p-calendar>
    <label class="m-2 ms-label-view">{{ "Start Date" | translator }}</label>
  </div>
</div>

<div class="row justify-content-center mt-4">
  <div
    *ngFor="let item of displayData; let index"
    class="col-md-2 col-12 justify-content-center text-center my-5 11111111"
  >
    <div
      class="v4-icone-card card w-100 h-100 d-flex align-items-center justify-content-space-around py-2 px-1"
    >
      <div class="card-img-entity">
        <img
          *ngIf="checkisImg(item?.image_sq); else elseBlock"
          [src]="staticURL + item?.image_sq"
          class="img-fluid p-1 img-cicle-type"
        />
        <ng-template #elseBlock>
          <i class="{{ item?.image_sq }} p-2" style="font-size: 1rem"></i>
        </ng-template>
      </div>

      <span class="title-text v4-color-white mt-3">{{
        item.key | translator
      }}</span>
      <hr class="hr" />
      <span class="total-text v4-color-white" *ngFor="let ele of item.data"
        >{{ ele.key | translator }} : {{ ele.count }}</span
      >

      <button
        pButton
        type="button"
        icon="pi pi-chevron-down"
        class="showchildbutton"
        *ngIf="item && item.children && item.children.length > 0"
        (click)="showchildrenof(item.children, item)"
      ></button>
    </div>
  </div>

  <p-dialog
    [blockScroll]="true"
    [draggable]="false"
    [(visible)]="showchilddialog"
    (onHide)="onDialogHide()"
    style="padding-bottom: 30px"
    [style]="{ width: '80%', minWidth: '50vw', minHeight: '60vh' }"
  >
    <div class="container" style="min-width: 40vw">
      <div class="row justify-content-center mt-2">
        <div
          *ngFor="let parent_item of parents; let parent_index = index"
          class="col-12 justify-content-center text-center my-5"
          [ngClass]="
            parents.length + childrendata.length < 6
              ? 'col-md-4 col-12'
              : 'col-md-2 col-12'
          "
        >
          <div
            class="card selected w-100 h-100 d-flex align-items-center justify-content-space-around py-2 px-1"
          >
            <div class="card-img-entity">
              <img
                *ngIf="checkisImg(parent_item?.image_sq); else elseBlock"
                [src]="staticURL + parent_item?.image_sq"
                class="img-fluid p-1 img-cicle-type"
              />
              <ng-template #elseBlock>
                <i
                  class="{{ parent_item?.image_sq }} p-2"
                  style="font-size: 1rem"
                ></i>
              </ng-template>
            </div>

            <span class="title-text v4-color-white mt-3">{{
              parent_item.key
            }}</span>
            <hr class="hr" />
            <span
              class="total-text v4-color-white"
              *ngFor="let parent_ele of parent_item.data"
              >{{ parent_ele.key }} : {{ parent_ele.count }}</span
            >

            <button
              pButton
              type="button"
              icon="pi pi-chevron-down"
              class="showchildbutton"
              *ngIf="
                parent_item &&
                parent_item.children &&
                parent_item.children.length > 0
              "
              (click)="showchildrenof(parent_item.children, parent_item)"
            ></button>
          </div>
        </div>

        <div
          *ngFor="let child_item of childrendata; let child_index = index"
          class="col-md-4 col-12 justify-content-center text-center my-5"
          [ngClass]="
            parents.length + childrendata.length < 6 ? 'col-md-4' : 'col-md-2'
          "
        >
          <div
            class="v4-icone-card card w-100 h-100 d-flex align-items-center justify-content-space-around py-2 px-1"
          >
            <div class="card-img-entity">
              <img
                *ngIf="checkisImg(child_item?.image_sq); else elseBlock"
                [src]="staticURL + child_item?.image_sq"
                class="img-fluid p-1 img-cicle-type"
              />
              <ng-template #elseBlock>
                <i
                  class="{{ child_item?.image_sq }} p-2"
                  style="font-size: 1rem"
                ></i>
              </ng-template>
            </div>

            <span class="title-text v4-color-white">{{ child_item.key }}</span>
            <hr class="hr" />
            <span
              class="total-text v4-color-white mt-3"
              *ngFor="let child_ele of child_item.data"
              >{{ child_ele.key }} : {{ child_ele.count }}</span
            >

            <button
              pButton
              type="button"
              icon="pi pi-chevron-down"
              class="showchildbutton"
              *ngIf="
                child_item &&
                child_item.children &&
                child_item.children.length > 0
              "
              (click)="showchildrenof(child_item.children, child_item)"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
